import { FC } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslations } from '@altermaind/core/i18n';
import { Box, Button, Card, Typography } from '@altermaind/web/ui';
import { VerticalStepper } from '@/_shared/components/VerticalStepper';
import { Step } from '@/_shared/components/VerticalStepper/types';
import { Routes } from '@/_shared/constants/routes';
import { getEmployeesStatsCall } from '@/people/state/api';
import { useSurvey } from '@/surveys/state/hooks';

export const RecapPlatformBox: FC = () => {
  const t = useTranslations('dashboard.surveysBox');
  const navigate = useNavigate();

  const { total, invalid, completed } = getEmployeesStatsCall.hook();

  const goToAddPeople = () => {
    navigate(Routes.PeopleImport);
  };

  const goToReviewPeople = () => {
    navigate(Routes.PeopleReview);
  };

  const {
    goToSurveyHardSkill,
    goToSurveySoftSkill,
    organizationHasCampaignsSoftSkill,
    organizationHasCampaignsHardSkill,
  } = useSurvey();

  const steps: Step[] = [
    {
      title: total === 0 ? t('steps.step0.title') : t('steps.step1.title'),
      description:
        total > 0 ? (
          <Box>
            <Typography variant='p3/light'>{t('steps.step1.description')}</Typography>
            <Button
              data-testid='overview-employees-review-employee'
              onClick={goToReviewPeople}
              mt='s'
              variant='positive'
            >
              {t('steps.step1.ctaLabel')}
            </Button>
          </Box>
        ) : (
          <Box>
            <Typography variant='p3/light'>{t('steps.step4.description')}</Typography>
            <Button
              data-testid='overview-employees-add-employee'
              onClick={goToAddPeople}
              mt='s'
              variant='positive'
            >
              {t('steps.step4.ctaLabel')}
            </Button>
          </Box>
        ),
      isCompleted: completed === total && total > 0 && invalid === 0,
      iconName: 'edit',
    },
    {
      title: t('steps.step2.title'),
      description: (
        <Box>
          <Typography variant='p3/light'>{t('steps.step2.description')}</Typography>
          <Button onClick={goToSurveySoftSkill} mt='s' variant='positive'>
            {t('steps.step2.ctaLabel')}
          </Button>
        </Box>
      ),
      isDisabled: total === 0 || completed === 0,
      isCompleted: organizationHasCampaignsSoftSkill,
      iconName: 'survey',
    },
    {
      title: t('steps.step3.title'),
      description: (
        <Box>
          <Typography variant='p3/light'>{t('steps.step3.description')}</Typography>
          <Button onClick={goToSurveyHardSkill} mt='s' variant='positive'>
            {t('steps.step3.ctaLabel')}
          </Button>
        </Box>
      ),
      isDisabled: total === 0 || completed === 0,
      isCompleted: organizationHasCampaignsHardSkill,
      iconName: 'survey',
    },
  ];

  return (
    <Card>
      <Typography variant='h2' mb='xs'>
        {t('title')}
      </Typography>
      <VerticalStepper primaryStyle noBorder steps={steps} />
    </Card>
  );
};
